import { ChevronDown, Download, FileSpreadsheet, FileText } from 'lucide-react'
import Menu, { MenuItem } from './Menu'
import { kit } from './strings'
import './ExportMenu.css'

/**
 * One export control for the whole panel.
 *
 * The same Excel/PDF pair currently lives in four places in three different styles —
 * a table footer, a green/red pair in a toolbar, a header button. It is a secondary
 * action on every one of those screens, so it looks like one everywhere: a quiet
 * menu in the list's control strip.
 *
 * @param {(format: 'excel' | 'pdf') => void} onExport
 * @param {{trigger?: string, excel: string, pdf: string}} labels  page's own strings
 */
export default function ExportMenu({ onExport, labels }) {
  return (
    <Menu
      width="272px"
      align="end"
      trigger={({ toggle, open, id }) => (
        <button
          type="button"
          className={`export-menu__trigger${open ? ' is-open' : ''}`}
          onClick={toggle}
          aria-haspopup="true"
          aria-expanded={open}
          aria-controls={id}
          data-testid="export-menu"
        >
          <Download size={16} strokeWidth={1.75} />
          <bdi>{labels.trigger ?? kit.export}</bdi>
          <ChevronDown size={14} strokeWidth={2} />
        </button>
      )}
    >
      <MenuItem icon={FileSpreadsheet} onClick={() => onExport('excel')}>
        {labels.excel}
      </MenuItem>
      <MenuItem icon={FileText} onClick={() => onExport('pdf')}>
        {labels.pdf}
      </MenuItem>
    </Menu>
  )
}
